module.exports = __webpack_public_path__ + "static/media/send-mail.26d46f19.svg";